import { render } from "./EonTabMenuMobile.vue?vue&type=template&id=54b5b35d&scoped=true"
import script from "./EonTabMenuMobile.vue?vue&type=script&lang=js"
export * from "./EonTabMenuMobile.vue?vue&type=script&lang=js"

import "./EonTabMenuMobile.vue?vue&type=style&index=0&id=54b5b35d&lang=less"
import "./EonTabMenuMobile.vue?vue&type=style&index=1&id=54b5b35d&scoped=true&lang=css"

import exportComponent from "/Users/kacper/IdeaProjects/e.on-portal-awarie/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54b5b35d"]])

export default __exports__